module.exports = __webpack_public_path__ + "static/presencial-menor-2-71017c3bdfb0893e368225fdb63a39c5.jpg";